import { Gift } from "lucide-react";
import { CHRISTMAS_END, cutoffFor } from "../lib/christmas";

export const CustomCutoffNote = () => {
  const now = Date.now();
  const c = cutoffFor("custom");
  if (!c || now > CHRISTMAS_END) return null;
  const open = now <= c.until;
  return (
    <div data-testid="custom-christmas-cutoff"
      className="sm:col-span-2 rounded-2xl border-2 border-[var(--ink)] bg-[#c8102e] text-white px-4 py-3 flex items-start gap-3">
      <Gift className="w-5 h-5 mt-0.5 shrink-0" />
      <p className="text-sm sm:text-base">
        {open
          ? <>Want it for Christmas? Send your custom print idea by <strong>{c.day}</strong>.</>
          : <>The Christmas cutoff for custom prints ({c.day}) has passed, so new requests may not be ready before Christmas.</>}
      </p>
    </div>
  );
};

export const ChristmasCheckoutBanner = ({ method }) => {
  const now = Date.now();
  const c = cutoffFor(method);
  if (!c || now > CHRISTMAS_END) return null;
  const open = now <= c.until;
  return (
    <div data-testid="christmas-checkout-banner"
      className="mb-6 rounded-2xl border-2 border-[var(--ink)] bg-[#c8102e] text-white px-4 py-3 flex items-start gap-3 shadow-[4px_4px_0_#14101F]">
      <Gift className="w-5 h-5 mt-0.5 shrink-0" />
      <p className="text-sm sm:text-base">
        {open
          ? <>Ordering for Christmas? The last day for {method === "pickup" ? "pickup" : "courier"} orders is <strong>{c.day}</strong>.</>
          : <>The Christmas cutoff for {method === "pickup" ? "pickup" : "courier"} orders ({c.day}) has passed, so this order may not arrive before Christmas.</>}
      </p>
    </div>
  );
};
